// extracted by mini-css-extract-plugin
export var content = "InfoBar-module--content--B2op1";
export var root = "InfoBar-module--root--rgeXe";